<template>
  <p class="count" :class="{ disabled: disabled }">
    <input type="tel" v-model.number.lazy="number" @keypress="handleKeyPress" maxlength="4" />
    <button class="down" @click="onDecrease"></button>
    <button class="up" @click="onIncrease"></button>
  </p>
</template>

<script>
export default {
  props: {
    title: String,
    value: Number,
    target: Object,
    onChange: Function,
    disabled: Boolean,
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 999,
    },
    valid: {
      type: Function,
      default: (to, from) => false,
    },
  },
  data() {
    return {
      number: this.value,
    };
  },
  watch: {
    value(val) {
      if (this.number != val) {
        this.number = val;
      }
    },
    number(to, from) {
      let value = to || this.min || 0;
      if (to === '') {
        this.number = this.min;
      } else {
        const valid = this.valid(to, from);
        if (valid) {
          this.number = Number.isInteger(valid) ? valid : from;
        } else if (to > this.max) {
          this.number = this.max;
        } else if (!isNaN(value)) {
          this.onChange(value, this.target);
        } else {
          this.number = from;
        }
      }
    },
  },
  methods: {
    handleKeyPress(e) {
      const keyValue = e.keyCode;
      if (keyValue >= 48 && keyValue <= 57) {
        return true;
      } else {
        e.preventDefault();
        return false;
      }
    },
    onInput(event) {
      let value = event.target.value || '0';
      const newValue = parseInt(value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'));
      if (!isNaN(newValue)) {
        this.onChange(parseInt(newValue), this.target);
      }
    },
    onIncrease() {
      this.number += 1;
      //this.onChange(this.value + 1, this.target);
    },
    onDecrease() {
      if (this.number > 0) {
        this.number -= 1;
        //this.onChange(this.value - 1, this.target);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  background: #eee;
  & * {
    pointer-events: none;
  }
}
</style>
